import equalityComparator from '@utilities/validation/helpers/equality-comparator';
import validation from '@utilities/validation/regex';
import idx from 'idx';

const registerConstraints = function (locale, customValidationMessages) {
  const constraints = {
    dwfrm_register_profile_customer_firstname: {
      ...customValidationMessages.dwfrm_profile_customer_firstname,
      presence: {
        allowEmpty: false,
      },
      length: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_firstname.length),
        minimum: 1,
        maximum: 30,
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_firstname.format),
        pattern: validation.names,
      },
    },
    dwfrm_register_profile_customer_lastname: {
      ...customValidationMessages.dwfrm_profile_customer_lastname,
      presence: {
        allowEmpty: false,
      },
      length: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_lastname.length),
        minimum: 1,
        maximum: 30,
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_lastname.format),
        pattern: validation.names,
      },
    },
    dwfrm_register_profile_customer_email: {
      ...customValidationMessages.dwfrm_profile_customer_email,
      presence: {
        allowEmpty: false,
      },
      length: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_email.length),
        maximum: 50,
      },
      email: true,
    },
    dwfrm_register_profile_customer_emailconfirm: {
      ...customValidationMessages.dwfrm_profile_customer_emailconfirm,
      presence: {
        allowEmpty: false,
      },
      length: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_emailconfirm.length),
        maximum: 50,
      },
      email: true,
      equality: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_emailconfirm.equality),
        attribute: 'dwfrm_register_profile_customer_email',
        comparator: (value) => equalityComparator(value, 'dwfrm_register_profile_customer_email'),
      },
    },
    dwfrm_register_profile_login_password: {
      ...customValidationMessages.dwfrm_register_profile_login_password,
      presence: {
        allowEmpty: false,
      },
      length: {
        minimum: 8,
        maximum: 255,
        tokenizer: (value) => value.toString(),
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_register_profile_login_password.format),
        pattern: validation.passwordRegex,
      },
    },
    dwfrm_register_profile_login_passwordconfirm: {
      ...customValidationMessages.dwfrm_register_profile_login_password,
      equality: {
        ...idx(customValidationMessages, (_) => _.dwfrm_register_profile_login_password.equality),
        attribute: 'dwfrm_register_profile_login_password',
        comparator: (value) => equalityComparator(value, 'dwfrm_register_profile_login_password'),
      },
      presence: {
        allowEmpty: false,
      },
      length: {
        minimum: 8,
        maximum: 255,
        tokenizer: (value) => value.toString(),
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_register_profile_login_password.format),
        pattern: validation.passwordRegex,
      },
    },
    dwfrm_register_profile_customer_phone: {
      ...customValidationMessages.dwfrm_profile_customer_phone,
      presence: {
        allowEmpty: false,
      },
      length: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_phone.length),
        minimum: 10,
        maximum: 16,
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_phone.format),
        pattern: validation.phoneRegex,
      },
    },
    dwfrm_register_privacyTerms: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_privacyTerms),
    },
    dwfrm_register_privacyTermsConsumer: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_privacyTerms),
    },
    dwfrm_register_privacyTermsProfessional: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_privacyTerms),
    },
    dwfrm_register_profile_customer_accountType: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_accountType),
    },
    dwfrm_register_profile_customer_companyName: {
      ...customValidationMessages.dwfrm_register_profile_customer_companyName,
      presence: {
        allowEmpty: false,
      },
      length: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_companyName.length),
        maximum: 30,
      },
    },
    dwfrm_register_profile_customer_vatCode: {
      ...customValidationMessages.dwfrm_register_profile_customer_vatCode,
      presence: {
        allowEmpty: false,
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_vatCode.format),
      },
    },
    dwfrm_register_profile_customer_cd: {
      ...customValidationMessages.dwfrm_register_profile_customer_cd,
      presence: {
        allowEmpty: false,
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_register_profile_customer_cd.format),
        pattern: /^[A-Z0-9]{7}$/i,
      },
    },
    dwfrm_register_profile_customer_pec: {
      ...customValidationMessages.dwfrm_register_profile_customer_pec,
      presence: {
        allowEmpty: false,
      },
      format: {
        ...idx(customValidationMessages, (_) => _.dwfrm_register_profile_customer_pec.format),
        pattern: /^[a-zA-Z0-9-+]{1}[a-zA-Z0-9-.+]{0,62}[a-zA-Z0-9-+]{1}@[a-zA-Z0-9-.]{1,128}[.]{1}[a-zA-Z]{2,60}$/i,
      },
    },
  };

  const vatNumberKey = Object.keys(constraints).filter(
    (constraint) => constraint.indexOf('vatCode') !== -1,
  );

  switch (locale) {
    case 'GB':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{ pattern: /^(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$/i },
      };
      break;
    case 'FR':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{ pattern: /^(FR)?[0-9A-Z]{2}[0-9]{9}$/i },
      };
      break;
    case 'ES':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{ pattern: /^(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]$/i },
      };
      break;
    case 'DE':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{ pattern: /^(DE)?[0-9]{9}$/i },
      };
      break;
    case 'NL':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{ pattern: /^(NL)?[0-9]{9}B[0-9]{2}$/i },
      };
      break;
    case 'BE':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(BE)?[0-1][0-9]{9}$/i,
        },
      };
      break;
    case 'SE':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{ pattern: /^(SE)?[0-9]{12}$/i },
      };
      break;
    case 'DK':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(DK)?[0-9]{8}$/i,
        },
      };
      break;
    case 'NO':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(NO)?[0-9]{9}(MVA)$/i,
        },
      };
      break;
    case 'CH':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(CHE-?\d{3}(\.)?\d{3}(\.)?\d{3} ?(IVA|TVA|MWST))$/i,
        },
      };
      break;
    case 'CY':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(CY)?[0-9]{8}[A-Z]{1}$/i,
        },
      };
      break;
    case 'IT':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(IT)?[0-9]{11}$/i,
        },
      };
      break;
    case 'GR':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(EL)?[0-9]{9}$/i,
        },
      };
      break;
    case 'IE':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(IE)[0-9A-Z*+]{7}[A-Z]{1,2}$/i,
        },
      };
      break;
    case 'IS':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(VSK)?[0-9]{5,6}$/i,
        },
      };
      break;
    case 'FI':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(FI)?[0-9]{8}$/i,
        },
      };
      break;
    case 'SK':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(SK)?[0-9]{10}$/i,
        },
      };
      break;
    case 'RO':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(RO)?[0-9]{2,10}$/i,
        },
      };
      break;
    case 'PL':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(PL)?[0-9]{10}$/i,
        },
      };
      break;
    case 'HU':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(HU)?[0-9]{8}$/i,
        },
      };
      break;
    case 'CZ':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(CZ)?[0-9]{8,10}$/i,
        },
      };
      break;
    case 'LT':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(LT)?([0-9]{9}|[0-9]{12})$/i,
        },
      };
      break;
    case 'HR':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(HR)?[0-9]{11}$/i,
        },
      };
      break;
    case 'SI':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(SI)?[0-9]{8}$/i,
        },
      };
      break;
    case 'LV':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(LV)?[0-9]{11}$/i,
        },
      };
      break;
    case 'EE':
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{
          pattern: /^(EE)?[0-9]{9}$/i,
        },
      };
      break;
    default:
      constraints[vatNumberKey].format = {
        ...constraints[vatNumberKey].format,
        ...{ pattern: /.*/i },
      };
      break;
  }

  return constraints;
};

export default registerConstraints;
